class SubscriptionPicker extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.sellingPlanContainer = this.querySelector('.selling-plan-fieldset');
    this.tieredPricingContainer = this.querySelector('.tiered-pricing-fieldset');
    this.purchaseOptions = this.querySelectorAll('input[name="purchaseOption"]')
    this.sellingPlanInput = document.querySelectorAll('input[name="selling_plan"]')
    this.cartBubble = document.querySelector('#cart-icon-bubble');
    this.form = document.querySelector('form[action="/cart/add"]');
    this.submitFormButton = this.form.querySelector('[type="submit"]');

    if(this.form) {
      this.form.addEventListener('submit', this.onFormSubmitHandler.bind(this));
    }

    this.classList.add('loading');

    this.purchaseOptions.forEach(function(radio) {
      if( radio.value == 'subscription' && radio.checked) {
        _this.init()
      }
    });

    this.purchaseOptions.forEach(function (radio) {
      radio.addEventListener('change', function (event) {
        if(event.target.value == 'onetime') { // one time select
          document.querySelectorAll('input[name="selling_plan"]').forEach(function(input) {
            input.value = ''; // clear the selling plan id
          });
          _this.sellingPlanContainer.classList.add('hidden');
          _this.tieredPricingContainer.classList.remove('hidden');
          _this.initTieredPricing();
        } else {
          _this.sellingPlanContainer.classList.remove('hidden');
          _this.tieredPricingContainer.classList.add('hidden');
          _this.updateProductFormQuantity(1);
          _this.init()
        }
      });
    });

    document.addEventListener('rebuy:smartcart.ready', (event) => {
      // const smartcart = event.detail.smartcart;
      _this.classList.remove('loading');
    });

    // document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
    //   const smartcart = event.detail.smartcart;
    //   let item = event.detail.item;

    //   console.log('item', item)
    // });

    // document.addEventListener('rebuy:cart.add', (event) => { 
    // });
    document.addEventListener('rebuy:cart.change', (event) => { 
      // console.log('rebuy:cart.change event', event.detail.cart.cart); 
      const cart = event.detail.cart.cart;

      if(this.cartBubble.querySelector('.cart-count-bubble')) {
        this.cartBubble.querySelector('.cart-count-bubble span').innerText = cart.item_count
      } else {
        const newDiv = document.createElement("div"); 
        newDiv.classList.add('cart-count-bubble')
        newDiv.innerHTML = `<span>${cart.item_count}</span>`; 
        this.cartBubble.appendChild(newDiv); 
      }

      if(cart.item_count == 0) {
        this.cartBubble.querySelector('.cart-count-bubble')?.classList.add('hidden')
      } else {
        this.cartBubble.querySelector('.cart-count-bubble')?.classList?.remove('hidden')
      }

      this.submitFormButton.setAttribute('aria-disabled', false);
      this.submitFormButton.classList.remove('loading');
      this.submitFormButton.querySelector('.loading__spinner').classList.add('hidden');
    });
  }

  onFormSubmitHandler(evt) {
    this.submitFormButton.setAttribute('aria-disabled', true);
    this.submitFormButton.classList.add('loading');
    this.submitFormButton.querySelector('.loading__spinner').classList.remove('hidden');
  }

  initTieredPricing() {
    const _this = this;

    this.tieredPricingContainer.querySelectorAll('input[type="radio"]:checked').forEach(function(radio) {
      _this.updateTieredPricing(radio.dataset.discount);
      _this.updateProductFormQuantity(radio.value);
    });

    this.tieredPricingContainer.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function (event) {
        _this.updateProductFormQuantity(this.value);
        _this.updateTieredPricing(this.dataset.discount);
      });
    });
  }

  updateTieredPricing(discount) {
    let priceWrapper = document.querySelector('label.onetime-radio .radio__price');
    let price = priceWrapper.querySelector('i').innerText;
    
    if(discount != 0){
      priceWrapper.querySelector('i').classList.remove('hidden');
      
      priceWrapper.querySelector('b').innerText = `$${(parseFloat(price.replace('$', '')) - discount).toFixed(2)}`;

      this.priceAnimation();
    } else {
      priceWrapper.querySelector('b').innerText = price;
      priceWrapper.querySelector('i').classList.add('hidden');
    }

    document.querySelectorAll('input[name="selling_plan"]').forEach(function(input) {
      input.value = ''; // clear the selling plan id
    }); // make sure that the selling plan value is cleared
  }

  priceAnimation() {
    let priceElem = document.querySelector(`.onetime-radio .radio__price`);
    if(priceElem) {
      priceElem.classList.add('highlight')

      let parentElem = priceElem.querySelector('.price-change');

      console.log('parentElem', parentElem)

      for (var i = 0; i < 360; i += 10) {
        const particle = document.createElement('div');
        particle.style = `--r:${i}deg`;
        parentElem.append(particle);
      }

      parentElem.classList.add('show')
  
      setTimeout(function() {
        parentElem.innerHTML = '';
      }, 1300);
  
      setTimeout(function() {
        priceElem.classList.remove('highlight')
      }, 2000);
    }
	}

  updateProductFormQuantity(qty) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(productForm) {
      if(productForm.querySelector('input[name="quantity"]')) {
        productForm.querySelector('input[name="quantity"]').value = qty;
      } else {
        var qty_input = document.createElement('input');
        qty_input.name = "quantity";
        qty_input.value = qty;
        qty_input.type = "hidden";
        productForm.appendChild(qty_input);
      }
    });
  }

  init() {
    const _this = this

    document.querySelectorAll('.selling-plan-fieldset').forEach(function(sellingPlanContainer) {
      var product = JSON.parse(document.getElementById('selling-plan-json-' + sellingPlanContainer.dataset.id).innerHTML);

      // Get all forms for this product
      for(var i in product.variants) {
        document.querySelectorAll('form[action*="/cart/add"]').forEach(function(productForm) {
          var variant_field = productForm.querySelector('[name="id"]');

          var external_variant_field = false;
          if(!variant_field && productForm.getAttribute('id') !== undefined) {
            variant_field = document.querySelector('[name="id"][form="' + productForm.getAttribute('id') + '"]');
            external_variant_field = true;
          }

          if(variant_field && (variant_field.value == product.variants[i].id || (variant_field.value == '' && variant_field.options !== undefined && variant_field.options[0].value == product.variants[i].id))) {
            productForm.classList.add('selling-plan-form-' + product.id);

            productForm.addEventListener('change', function (e) {
              console.log('change')
            });
          }
        });
      }

      sellingPlanContainer.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function (event) {
          _this.updateProductForm(product.id, this.value, this.dataset.price);
        });
      });

      
      // when the page first loads, make sure the selling plan id is added to the forms
      var selected_radio = sellingPlanContainer.querySelectorAll('input[type="radio"]:checked').forEach(function(radio) {
        _this.updateProductForm(product.id, radio.value, radio.dataset.price);
      });
    });
  }

  updateProductForm(product_id, selling_plan_id, price) {
    document.querySelectorAll('.selling-plan-form-' + product_id).forEach(function(productForm) {
      if(productForm.querySelector('input[name="selling_plan"]')) {
        productForm.querySelector('input[name="selling_plan"]').value = selling_plan_id;
      } else {
        var selling_plan_input = document.createElement('input');
        selling_plan_input.name = "selling_plan";
        selling_plan_input.value = selling_plan_id;
        selling_plan_input.type = "hidden";
        productForm.appendChild(selling_plan_input);
      }
    });
  }
}

customElements.define('subscription-picker', SubscriptionPicker);
